import { useLivePayouts } from "./useLivePayouts";
import { useMemo } from "react";
import { ProductType } from "motty-utils";
import { enumValues } from "../helpers/enumUtils";
import { getTeamCountry } from "../helpers/getTeamCountry";
import { createSellersStatistics } from "../helpers/createStatistics";
const createCountryStatistics = (country, payouts = [], product) => {
    const countryPayouts = payouts.filter(p => getTeamCountry(p.team) === country);
    const orderBy = product === ProductType.CreditCard ? ['count', 'amount'] : ['amount', 'count'];
    const topSellers = createSellersStatistics(countryPayouts, orderBy);
    return ({
        topSellers
    });
};
export const useCountryStatistics = (country) => {
    const livePayoutsCreditCard = useLivePayouts(ProductType.CreditCard);
    const livePayoutsConsumerLoan = useLivePayouts(ProductType.ConsumerLoan);
    const livePayoutsMortgage = useLivePayouts(ProductType.Mortgage);
    const livePayoutsByProduct = useMemo(() => ({
        [ProductType.CreditCard]: livePayoutsCreditCard,
        [ProductType.ConsumerLoan]: livePayoutsConsumerLoan,
        [ProductType.Mortgage]: livePayoutsMortgage,
    }), [livePayoutsCreditCard, livePayoutsConsumerLoan, livePayoutsMortgage]);
    return useMemo(() => {
        const countryStatistics = {};
        enumValues(ProductType).forEach(product => {
            countryStatistics[product] = createCountryStatistics(country, livePayoutsByProduct[product], product);
        });
        return countryStatistics;
    }, [country, livePayoutsByProduct]);
};
